<template>
  <v-dialog v-model="dialogModel" fullscreen scrollable>
    <v-card>
      <v-card-title class="d-flex align-center">
        <div>
          <div class="text-h6 font-weight-bold">
            ODT {{ odtIdDisplay }}
          </div>
          <div class="text-caption grey--text text--darken-1">
            {{ odtClaveDisplay }}
          </div>
        </div>
        <v-spacer />
        <v-btn icon @click="dialogModel = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row dense class="mb-2">
          <v-col v-for="item in resumenODT" :key="item.label" cols="12" sm="6" md="4" lg="3">
            <div class="text-caption grey--text text--darken-1">{{ item.label }}</div>
            <div class="text-body-2 font-weight-medium">{{ item.value }}</div>
          </v-col>
        </v-row>

        <v-tabs v-model="tab" grow>
          <v-tab>Operaciones Reales</v-tab>
          <v-tab>Piezas No OK</v-tab>
          <v-tab>Paros</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-expansion-panels class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Filtros
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row dense>
                    <v-col cols="12" md="9">
                      <v-text-field
                        v-model="filtrosDraft.operaciones"
                        label="Buscar en operaciones reales"
                        clearable
                        hide-details
                      />
                    </v-col>
                    <v-col cols="12" md="3" class="d-flex justify-end">
                      <v-btn color="primary" @click="aplicarFiltro('operaciones')">
                        Buscar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-data-table :headers="operacionesHeaders" :items="operacionesRowsFiltradas" dense class="elevation-1 mt-3">
              <template v-slot:no-data>
                {{ operacionesRows.length ? "Sin resultados con el filtro aplicado." : "Sin datos de operaciones reales para esta ODT." }}
              </template>
            </v-data-table>
          </v-tab-item>

          <v-tab-item>
            <v-expansion-panels class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Filtros
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row dense>
                    <v-col cols="12" md="9">
                      <v-text-field
                        v-model="filtrosDraft.noOk"
                        label="Buscar en piezas no OK"
                        clearable
                        hide-details
                      />
                    </v-col>
                    <v-col cols="12" md="3" class="d-flex justify-end">
                      <v-btn color="primary" @click="aplicarFiltro('noOk')">
                        Buscar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-data-table :headers="piezasNoOkHeaders" :items="piezasNoOkRowsFiltradas" dense class="elevation-1 mt-3">
              <template v-slot:no-data>
                {{ piezasNoOkRows.length ? "Sin resultados con el filtro aplicado." : "Sin datos de piezas no OK para esta ODT." }}
              </template>
            </v-data-table>
          </v-tab-item>

          <v-tab-item>
            <v-expansion-panels class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Filtros
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row dense>
                    <v-col cols="12" md="9">
                      <v-text-field
                        v-model="filtrosDraft.paros"
                        label="Buscar en paros"
                        clearable
                        hide-details
                      />
                    </v-col>
                    <v-col cols="12" md="3" class="d-flex justify-end">
                      <v-btn color="primary" @click="aplicarFiltro('paros')">
                        Buscar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-data-table :headers="parosHeaders" :items="parosRowsFiltradas" dense class="elevation-1 mt-3">
              <template v-slot:no-data>
                {{ parosRows.length ? "Sin resultados con el filtro aplicado." : "Sin datos de paros para esta ODT." }}
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    odt: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      tab: 0,
      filtrosDraft: {
        operaciones: "",
        noOk: "",
        paros: "",
      },
      filtrosAplicados: {
        operaciones: "",
        noOk: "",
        paros: "",
      },
    };
  },

  computed: {
    dialogModel: {
      get() {
        return this.value;
      },
      set(valor) {
        this.$emit("input", valor);
      },
    },

    odtSafe() {
      return this.odt && typeof this.odt === "object" ? this.odt : {};
    },

    odtKeyMap() {
      const map = new Map();
      Object.entries(this.odtSafe).forEach(([key, value]) => {
        map.set(this.normalizeKey(key), value);
      });
      return map;
    },

    odtIdDisplay() {
      const id = this.findValue(["idTrabajoOrden", "idODT", "id"]);
      return this.toDisplayValue(id || "-");
    },

    odtClaveDisplay() {
      const clave = this.findValue(["clave", "codigo", "folio"]);
      return clave ? `Clave ${this.toDisplayValue(clave)}` : "Sin clave";
    },

    resumenODT() {
      const condicion = this.findValue(["condicion", "activa"]);
      const condicionTexto = typeof condicion === "boolean"
        ? (condicion ? "Activa" : "Inactiva")
        : this.toDisplayValue(condicion);

      const items = [
        { label: "ID Trabajo Orden", value: this.toDisplayValue(this.findValue(["idTrabajoOrden", "idODT", "id"])) },
        { label: "Clave", value: this.toDisplayValue(this.findValue(["clave", "codigo", "folio"])) },
        { label: "Condición", value: condicionTexto },
        { label: "Fecha Creación", value: this.toDisplayValue(this.findValue(["fechaCreacion", "creacion"])) },
        { label: "Fecha Entrega", value: this.toDisplayValue(this.findValue(["fechaEntrega", "entrega"])) },
        { label: "Fecha Inicio Producción", value: this.toDisplayValue(this.findValue(["fechaInicioProduccion"])) },
      ];

      return items.filter((item) => item.value !== "-");
    },

    operacionesRows() {
      const source = this.findArray([
        "operacionesReales",
        "operacionRealReportes",
        "operacionesODT",
        "operaciones",
      ]);
      return this.normalizeRows(source);
    },

    piezasNoOkRows() {
      const source = this.findArray([
        "piezasNoOk",
        "piezasNOK",
        "noOkDetalles",
        "detallesNoOk",
        "noOk",
      ]);
      return this.normalizeRows(source);
    },

    parosRows() {
      const direct = this.findArray(["paros"]);
      if (direct.length) {
        return this.normalizeRows(direct);
      }

      const programados = this.findArray(["parosProgramados"]);
      const noProgramados = this.findArray(["parosNoProgramados"]);
      const mixed = [
        ...programados.map((item) => ({ tipoParo: "Programado", ...item })),
        ...noProgramados.map((item) => ({ tipoParo: "No programado", ...item })),
      ];

      return this.normalizeRows(mixed);
    },

    operacionesHeaders() {
      return this.createHeaders(this.operacionesRows);
    },

    piezasNoOkHeaders() {
      return this.createHeaders(this.piezasNoOkRows);
    },

    parosHeaders() {
      return this.createHeaders(this.parosRows);
    },

    operacionesRowsFiltradas() {
      return this.filtrarRows(this.operacionesRows, this.filtrosAplicados.operaciones);
    },

    piezasNoOkRowsFiltradas() {
      return this.filtrarRows(this.piezasNoOkRows, this.filtrosAplicados.noOk);
    },

    parosRowsFiltradas() {
      return this.filtrarRows(this.parosRows, this.filtrosAplicados.paros);
    },
  },

  watch: {
    value(next) {
      if (!next) {
        this.tab = 0;
        this.filtrosDraft = {
          operaciones: "",
          noOk: "",
          paros: "",
        };
        this.filtrosAplicados = {
          operaciones: "",
          noOk: "",
          paros: "",
        };
      }
    },
  },

  methods: {
    aplicarFiltro(tabKey) {
      if (!Object.prototype.hasOwnProperty.call(this.filtrosAplicados, tabKey)) return;
      const texto = this.filtrosDraft[tabKey] || "";
      this.filtrosAplicados[tabKey] = texto.trim().toLowerCase();
    },

    filtrarRows(rows, termino) {
      if (!termino) return rows;
      return rows.filter((row) => Object.values(row).some((value) => String(value || "").toLowerCase().includes(termino)));
    },

    normalizeKey(key) {
      return String(key || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9]/g, "")
        .toLowerCase();
    },

    findValue(candidates) {
      for (const candidate of candidates) {
        const key = this.normalizeKey(candidate);
        if (this.odtKeyMap.has(key)) {
          return this.odtKeyMap.get(key);
        }
      }
      return null;
    },

    findArray(candidates) {
      for (const candidate of candidates) {
        const key = this.normalizeKey(candidate);
        const value = this.odtKeyMap.get(key);
        if (Array.isArray(value)) {
          return value;
        }
      }
      return [];
    },

    normalizeCell(value) {
      if (value === null || value === undefined || value === "") return "-";

      if (Array.isArray(value)) {
        if (!value.length) return "-";
        if (value.every((item) => typeof item !== "object" || item === null)) {
          return value.join(", ");
        }
        return `${value.length} elementos`;
      }

      if (typeof value === "object") {
        const json = JSON.stringify(value);
        return json.length > 120 ? `${json.slice(0, 117)}...` : json;
      }

      return value;
    },

    normalizeRows(list) {
      if (!Array.isArray(list)) return [];

      return list.map((row) => {
        if (row === null || row === undefined) {
          return { valor: "-" };
        }

        if (typeof row !== "object" || Array.isArray(row)) {
          return { valor: this.normalizeCell(row) };
        }

        const normalized = {};
        Object.entries(row).forEach(([key, value]) => {
          normalized[key] = this.normalizeCell(value);
        });
        return normalized;
      });
    },

    createHeaders(rows) {
      if (!rows.length) return [];

      return Object.keys(rows[0]).map((key) => ({
        text: this.humanizeKey(key),
        value: key,
        sortable: true,
      }));
    },

    humanizeKey(key) {
      return String(key || "")
        .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
        .replace(/_/g, " ")
        .replace(/\s+/g, " ")
        .trim()
        .replace(/^./, (char) => char.toUpperCase());
    },

    toDisplayValue(value) {
      const normalized = this.normalizeCell(value);
      return normalized === "-" ? "-" : String(normalized);
    },
  },
};
</script>
